import { render, staticRenderFns } from "./course_detail.vue?vue&type=template&id=329eff94"
import script from "./course_detail.vue?vue&type=script&lang=js"
export * from "./course_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports